import React from "react";

interface GhostModeIconProps {
  width?: number;
  height?: number;
  color?: string;
}

export const GhostModeIcon: React.FC<GhostModeIconProps> = ({
  width = 24,
  height = 24,
  color = "#141218",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0653 7H8.93472C5.68843 7 5.68843 12 8.93472 12H15.0653C18.3116 12 18.3116 7 15.0653 7Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5C8.44772 8.5 8 8.94772 8 9.5C8 10.0523 8.44772 10.5 9 10.5Z"
        fill={color}
      />
      <path
        d="M15 10.5C15.5523 10.5 16 10.0523 16 9.5C16 8.94772 15.5523 8.5 15 8.5C14.4477 8.5 14 8.94772 14 9.5C14 10.0523 14.4477 10.5 15 10.5Z"
        fill={color}
      />
      <path
        d="M12.093 16.5455C16.1097 16.5455 19.3658 13.2894 19.3658 9.27275C19.3658 5.25612 16.1097 2 12.093 2C8.07642 2 4.82031 5.25612 4.82031 9.27275C4.82031 13.2894 8.07642 16.5455 12.093 16.5455Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21.9241C4.83428 18.7546 8.16572 16.6211 12.0909 16.6211C16.0161 16.6211 19.3475 18.7546 21.1818 21.9241"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
